App.Model.Contact = Backbone.Model.extend({
  validation: {
    subject: {
      required: true
      msg: __('subject_required')
    }
    another_subject: {
      fn: (value, attr, computedState) ->
        if $('#subject').val() == 'th' && !value
          return 'required'
      msg: __('subject_required')
    }
    message: {
      required: true
      msg: __('message_required')
    }
    name: {
      required: true
      msg: __('name_required')
    }
    email: [
      {
        required: true
        msg: __('cart_email_required')
      }
      {
        pattern: 'email'
        msg: __('cart_email_invalid')
      }
    ]
  }
  
  initialize: ->
    if App.is_logged
      delete @validation['email']
      delete @validation['name']
})

App.View.Contact = Backbone.View.extend({
  el: '.form'
  events: {
    'change input': viewUpdateModel
    'change textarea': viewUpdateModel
    'change select': 'change'
  }
  initialize: ->
    Backbone.Validation.bind this, {
      valid: validInput
      invalid: invalidInput
    }
  change: (evt) ->
    viewUpdateModel.call(this, evt)
    el = $(evt.currentTarget)
    if el.prop('id') == 'subject'
      if el.val() == 'th'
        $('.other-subject').show()
      else
        $('.other-subject').hide()
    return
})

$ ->
  model = new App.Model.Contact
  view = new App.View.Contact {
    model: model
  }
  $('#send-message').on 'click', ->
    $('#failed').hide()
    errors = model.validate()
    if !errors
      $('#send-message').hide()
      #$('#send-message').addClass('disabled')
      $('#sending-message').fadeIn()
      data = model.toJSON()
      subject = $('#subject')
      data.subject = if subject.val() == 'th' \
        then data.another_subject \
        else $('#subject option[value="' + subject.val() + '"]').text()
      delete data.another_subject
      $.post '/contact', data, (json) ->
        if json.success
          $('.form').hide()
          $('#success').show()
        else
          $('#failed').show()
        return
    false
  return
